<template lang="pug">
    div
        .mx-auto(v-if="communicationType === 'Phone'" style="max-width: 550px;")
            IncomingDetails.no-padding(
                :calls-waiting="callsWaiting"
            )
            v-alert(
                v-if="!hasLoggedInQueues"
                type="warning"
                prominent
                border="left"
                class="mb-4"
                elevation="2"
            )
                | You will not receive any customers until you log into at least one queue.

            v-card.mx-auto.mt-md-4(outlined tile max-width="550")
                .pa-md-4
                    v-progress-linear(indeterminate color='yellow darken-2')
                
                v-card-text
                    p.text-h4.text--primary.text-center
                        | Please hang tight
                    .text--primary.text-center(v-if="validText")
                        | {{ text }}
                    .text--primary.text-center(v-else)
                        | We will send you a customer as soon as one becomes available   
                
                v-card-text
                    .text-center
                        ManualMode(
                            :enter-manual-mode="enterManualMode"
                            :exit-manual-mode="exitManualMode"
                            :has-logged-in-queues="hasLoggedInQueues"
                            :is-manual-mode="isManualMode"
                            :organization-users="organizationUsers"
                            :render-enroll-as-eligible="true"
                        )

        v-card.mx-auto(outlined tile max-width="550" v-else)
            .pa-md-4
                v-progress-linear(indeterminate color='yellow darken-2')

            v-card-text
                p.text-h4.text--primary.text-center
                    | Please hang tight
                .text--primary.text-center(v-if="validText")
                    | {{ text }}
                .text--primary.text-center(v-else)
                    | We will send you a customer as soon as one becomes available   

            .pa-md-4
                v-progress-linear(
                    indeterminate
                    color='yellow darken-2'
                )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import IncomingDetails from '@/components/communication_center/phone/incoming_details.vue';
    import ManualMode from '@/components/communication_center/shared/manual_mode.vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            validText() {
                return this.text?.length > 0;
            },
        },
        components: {
            IncomingDetails,
            ManualMode,
        },
        props: {
            callsWaiting: Array,
            communicationType: String,
            enterManualMode: Function,
            exitManualMode: Function,
            hasLoggedInQueues: Boolean,
            isManualMode: Boolean,
            organizationUsers: Array,
            text: String,
        },
    });
</script>

<style lang="scss" scoped>
</style>
